import apiFetch from '../apiFetch'

export default function (idGrupoUsuario) {
  return apiFetch({endPoint: `GrupoUsuario/getGrupoUsuario?idGrupoUsuario=${idGrupoUsuario}`, method: 'GET', body: null})
}